import { appendPersonalDocOcrFields } from "./ocrTextUtils";

export const buildPersonalDocFormData = ({
  clientId,
  userId,
  item,
  ocr = {},
}) => {
  const formData = new FormData();
  formData.append("clientid", clientId);
  formData.append("addedby", "cms");
  formData.append("addedid", userId);
  formData.append("file", item.file);
  formData.append(
    "type",
    item.personalCategory || item.category || "",
  );
  formData.append("name", item.file.name);
  formData.append("document_name", item.document_name.trim());
  const userDescription = item.description?.trim();
  if (userDescription) {
    formData.append("description", userDescription);
  }
  formData.append("is_financial", "0");
  appendPersonalDocOcrFields(formData, ocr);
  return formData;
};
